// Resolves the aspect ratio (width / height, as a unitless number for CSS
// `aspect-ratio`) used to frame the uploaded clip on the success screen.
//
// The frame must hug the real shape of the clip so a portrait (9:16), landscape
// (16:9), or square (1:1) video each fills its box with no dead space. We prefer
// the ratio measured from the actual <video> element (always correct, even if the
// backend metadata is missing or wrong), then fall back to the backend-provided
// decimal, then to a sane default derived from the orientation flag.
export function resolveClipAspectRatio(
    measured: number | null | undefined,
    aspectRatioDecimal: number | null | undefined,
    isVertical: boolean,
): number {
    if (measured && measured > 0 && Number.isFinite(measured)) {
        return measured;
    }
    if (aspectRatioDecimal && aspectRatioDecimal > 0 && Number.isFinite(aspectRatioDecimal)) {
        return aspectRatioDecimal;
    }
    // No reliable data — assume the dominant case (portrait) unless flagged landscape.
    return isVertical ? 9 / 16 : 16 / 9;
}
